export interface UserProfileFieldProps {
  label: string;
  value: string;
}

/** Readonly HTML field — DevExtreme TextBox can hit React #185 under React 19. */
export function UserProfileField({ label, value }: UserProfileFieldProps) {
  return (
    <div className="user-profile-field">
      <label className="user-profile-field__label">{label}</label>
      <input className="user-profile-field__input" type="text" value={value} readOnly />
    </div>
  );
}
